export const STRIPE_IDENTIFICATION_VERIFICATION_REQUEST = 'STRIPE_IDENTIFICATION_VERIFICATION_REQUEST';
export const STRIPE_IDENTIFICATION_VERIFICATION_SUCCESS = 'STRIPE_IDENTIFICATION_VERIFICATION_SUCCESS';
export const STRIPE_IDENTIFICATION_VERIFICATION_FAILURE = 'STRIPE_IDENTIFICATION_VERIFICATION_FAILURE';

export const CREATE_STRIPE_CUSTOMER_REQUEST = 'CREATE_STRIPE_CUSTOMER_REQUEST';
export const CREATE_STRIPE_CUSTOMER_SUCCESS = 'CREATE_STRIPE_CU_SUCCESSSTOMER';
export const CREATE_STRIPE_CUSTOMER_FAILURE = 'CREATE_STRIPE_CUSTOMER_FAILURE';